import ua from '@/utils/platform'
import { getWxUserInfo, wechatAuthCode } from '@/utils/wx'
import { ref, computed } from '@vue/reactivity'
import { getQueryString } from '@/utils/url'
import { gotByRoute } from '@/utils/app'
import { wxShare } from '@/utils/wx'
import { arrangeDate, throttle } from '@/utils/regular'
import CImage from '@/components/common/cimage.vue'
import request from '@/api'
import { appRoutes } from './appRoutes'
import store from '@/store'
import { qtDownload } from './qt'
const openAppLink = 'https://vip.foshanplus.com/app/download.html'
import wx from 'weixin-js-sdk'

export default function () {
  // 在H5页面中调用此函数来跳转到小程序页面
  const navigateToWechatMiniProgram = () => {
    // 如果是小程序 提示打开佛山+客户端
    // alert('更多精彩请打开佛山+App')
    if (typeof wx !== 'undefined') {
      wx.miniProgram.navigateTo({
        url: '/packageNews/pages/lead/lead?tip=<div>即将前往客服会话</div><div>回复任意内容打开/下载佛山+客户端</div>参与社区互动' // 小程序中的页面路径
      })
    } else {
      alert('请在微信内置浏览器中打开H5页面！')
    }
  }
  /**
   * 打开链接
   * @param {*} type 类型 // 0友趣详情 1友趣频道 2友趣话题
   * 3问吧话题 4问吧详情 5找记者详情页面 6全民拍详情页面
   * @param {*} id
   */
  const openApp = (route, isHome = false) => {
    if (ua.isMini) {
      // 如果是小程序 提示打开佛山+客户端
      // alert('更多精彩请打开佛山+App')
      navigateToWechatMiniProgram()
      return
    }

    if (isIframe.value) {
      return false
    }
    if (isHome) {
      // 是否只打开客户端首页
      location.href = openAppLink
      return
    }
    if (route) {
      location.href = `${openAppLink}?route=${encodeURIComponent(route)}`
      return
    }
    const type = store.state.pageInfo.pageType
    // id
    const id = store.state.pageInfo.id
    // 标题
    // const title = store.state.pageInfo.title
    // 频道id
    const channelId = store.state.pageInfo.cid ? store.state.pageInfo.cid : store.state.pageCid
    const query = getQueryString()
    // 投放位置
    // let loc = query && query.loc
    // loc = !loc ? '' : decodeURIComponent(loc)
    qtDownload(store.state.pageInfo, query, type)
    // poc埋点
    // window.pocPushDownloadByCid({ content_id: id, content_title: title ? title : '', content_cid: channelId, throw_loc: loc })
    if (type > appRoutes.length) {
      return
    }
    const routePath = appRoutes[type] + '?id=' + id
    setTimeout(() => {
      location.href = `${openAppLink}?route=${encodeURIComponent(routePath)}&cid=${channelId}`
    }, 100)
  }

  const openLink = (outsideLink, innerLink) => {
    if (store.state.isApp && innerLink) {
      gotByRoute(innerLink)
      return
    }
    const urlRegex = /^(http:\/\/|https:\/\/)/
    if (urlRegex.test(outsideLink)) {
      setTimeout(() => {
        location.href = outsideLink
      }, 100)
      return
    }

    // setTimeout(() => {
    //   location.href = `${openAppLink}?route=${encodeURIComponent(routePath)}&cid=${channelId}`
    // }, 100)
  }

  const getAppSearch = (route, isHome = false) => {
    let appSearch = ''
    if (isHome) {
      // 是否只打开客户端首页
      return appSearch
    }
    if (route) {
      appSearch = `?route=${encodeURIComponent(route)}`
      return appSearch
    }
    const type = store.state.pageInfo.pageType
    // id
    const id = store.state.pageInfo.id
    // 标题
    // const title = store.state.pageInfo.title
    // 频道id
    const channelId = store.state.pageInfo.cid ? store.state.pageInfo.cid : store.state.pageCid
    const query = getQueryString()
    // 投放位置
    // let loc = query && query.loc
    // loc = !loc ? '' : decodeURIComponent(loc)
    qtDownload(store.state.pageInfo, query, type)
    // poc埋点
    // window.pocPushDownloadByCid({ content_id: id, content_title: title ? title : '', content_cid: channelId, throw_loc: loc })
    if (type > appRoutes.length) {
      return appSearch
    }
    const routePath = appRoutes[type] + '?id=' + id
    appSearch = `?route=${encodeURIComponent(routePath)}&cid=${channelId}`
    return appSearch
  }

  // 跳转新闻
  const openNews = (newsId) => {
    location.href = 'https://content.foshanplus.com/newsDetails.html?newsId=' + newsId
  }
  /**
   * 跳转链接
   * @param {*} location 对应地址
   * @param {*} id
   * @param {*} item 跳转对象
   */
  const openWebPage = (location, id, item) => {
    if (item && item.redirectType == 'DETAIL' && item.redirectPath && item.redirectPath.length > 0) {
      window.location.href = item.redirectPath
      return
    }
    const BASE_URL = process.env.NODE_ENV === 'production' ? '/fs-web-1/foshan-street/' : '/'
    window.location.href = `${BASE_URL}${location}?id=${id}`
  }

  const openCustomPage = (location, isReplace = false) => {
    const BASE_URL = process.env.NODE_ENV === 'production' ? '/fs-web-1/foshan-street/' : '/'
    if (isReplace) {
      window.location.replace(`${BASE_URL}${location}`)
    } else {
      window.location.href = `${BASE_URL}${location}`
    }
  }

  // 格式化时间
  const formatTime = computed(() => {
    return (time, format = 'MM-dd hh:mm') => {
      return arrangeDate(time, format)
    }
  })

  const loginHandle = (needOpenApp = true) => {
    if (isIframe.value == 1) {
      return Promise.reject()
    }
    const token = store.getters.getToken
    if (token && token.length > 0) {
      return Promise.resolve()
    }
    let query = getQueryString()
    let code = query && query.code
    if (ua.isWeixin) {
      if (code && code.length > 0) {
        return getWxUserInfo(code)
      } else {
        wechatAuthCode()
      }
    } else {
      // 不是微信 直接跳转到下载页
      if (needOpenApp) {
        openApp()
      }
      return Promise.reject()
    }
  }

  // 参与人数
  const joinCount = computed(() => {
    return (model) => {
      return Number(model.commentCount) + Number(model.fansCount) + Number(model.postCount)
    }
  })

  // 头像帖子信息
  const headPoster = computed(() => {
    return (type, item) => {
      if (type == 0 || type == 3) {
        // 问吧 匿名 3 找记者
        const poster = { ...item.poster, anonymous: item.anonymous }
        return poster
      } else if (item.handlePoster) {
        return item.handlePoster
      } else {
        return item.poster
      }
    }
  })
  // 点击广告
  const clickAd = (item) => {
    if (item.webUrl && item.webUrl.length > 0) {
      // 有webUrl
      location.href = item.webUrl
    } else if (item.url && item.url.length > 0) {
      // url
      if (item.url.indexOf('foshanplus://') == 0) {
        // 跳转到app
        location.href = `${openAppLink}?route=` + encodeURIComponent(item.url)
      } else if (item.url.indexOf('http') == 0) {
        // 跳转到链接
        location.href = item.url
      }
    }
  }

  // 是否为内嵌页面
  const isIframe = computed(() => {
    const query = getQueryString()
    if (query && query.iframe == 1) {
      return true
    }
    return false
  })

  const fs_device = computed(() => {
    const query = getQueryString()
    if (query && query.fs_device == 0) {
      return false
    }
    return true
  })

  return {
    ref,
    openApp,
    openLink,
    openNews,
    openWebPage,
    openCustomPage,
    getQueryString,
    gotByRoute,
    wxShare,
    computed,
    loginHandle,
    throttle,
    clickAd,
    getAppSearch,
    isIframe,
    fs_device,
    headPoster,
    joinCount, // 参与人数
    formatTime,
    CImage,
    request,
    store,
    navigateToWechatMiniProgram
  }
}
